module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 /* allowHtmlVariables title */ 
__p+='\n<a class="t-circle-link listItemButton listItemButton-upload"\n    href="javascript:void(0);">\n    ';
 // This image stretches container to fill height and width available while actual image is being fetched 
__p+='\n    <img class="listItemButton__moreButtonStretcher"\n        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNgYAAAAAMAASsJTYQAAAAASUVORK5CYII=">\n    <span class="listItemButton__content">\n        <span class="u-hideBelowTablet-inline">\n            <i class="icon icon-add-midBlue icon-xlarge u-halfSpaceBottom"></i>\n        </span>\n        <span class="u-hideAboveTablet">\n            <i class="icon icon-add-midBlue icon-medium"></i>\n        </span>\n        <span class="u-block">'+
((__t=( title ))==null?'':__t)+
'</span>\n    </span>\n</a>\n';
}
return __p;
};
